import { gql } from '@provision/graphql-client';

const CONVERSATION_TRIAGE_FIELDS = gql`
  fragment ConversationTriageFields on ConversationTriage {
    id
    conversationTriageId
    partnerId
    instructions
    actionConfig
    llmConfig
  }
`;

export const GET_TRIAGE_SETTINGS_PAGE_DATA_QUERY = gql`
  query GetTriageSettingsPageData($partnerId: Int!) {
    getTriageSettingsPageData(partnerId: $partnerId) {
      template {
        tools {
          name
          label
          description
        }
        defaultVisibility
        instructions
        llmConfig
      }
      currentTriage {
        enabled
        config {
          conversationTriageId
          instructions
          actionConfig
          llmConfig
        }
      }
    }
  }
`;

export const CREATE_CONVERSATION_TRIAGE = gql`
  mutation CreateConversationTriage($data: ConversationTriageDataInput) {
    createConversationTriage(data: $data) {
      ...ConversationTriageFields
    }
  }
  ${CONVERSATION_TRIAGE_FIELDS}
`;

export const UPDATE_CONVERSATION_TRIAGE = gql`
  mutation UpdateConversationTriage(
    $conditions: [ConditionInput]
    $data: ConversationTriageDataInput
  ) {
    updateConversationTriage(conditions: $conditions, data: $data) {
      ...ConversationTriageFields
    }
  }
  ${CONVERSATION_TRIAGE_FIELDS}
`;
